<template>
  <v-container fluid class="pa-0 ma-0">
    <div class="px-0 py-0 ma-0 d-flex justify-space-between">
      <div class="d-flex align-start flex-grow-1">
        <div>
          <ImageMedia
            data-testId="print-header-logo"
            style="max-width:120px;max-height:60px"
            :src="logoMediaObject"
            :defaultImage="Logo"
          />
        </div>
        <span
          class="body-2 mb-2 blue-grey--text text--darken-3 font-weight-bold ml-4"
        >
          {{ routineExecution.name }}
        </span>
      </div>

      <div class="px-0 d-flex flex-column" style="min-width:200px">
        <div
          v-if="routineExecution.status"
          class="d-flex align-center justify-end"
        >
          <p
            class="caption blue-grey--text text--darken-3 font-weight-bold mb-0"
          >
            {{ $t('common.status') }}:
            <span class="font-weight-medium">{{ routineExecutionStatus }}</span>
          </p>
        </div>
        <div
          v-if="routineExecution.createdAt"
          class="d-flex align-center justify-end"
        >
          <p
            class="caption blue-grey--text text--darken-3 font-weight-bold mb-0"
          >
            {{ $t('problem_solving.print.creation_date') }}:
            <span class="font-weight-medium">{{
              formatDate(routineExecution.createdAt, 'MMM D, YYYY')
            }}</span>
          </p>
        </div>
        <div
          v-if="routineExecution.completedAt"
          class="d-flex justify-end align-center"
        >
          <p
            class="caption blue-grey--text text--darken-3 font-weight-bold mb-0"
          >
            {{ $t('problem_solving.print.completion_date') }}:
            <span class="font-weight-medium">{{
              formatDate(routineExecution.completedAt, 'MMM D, YYYY')
            }}</span>
          </p>
        </div>
      </div>
    </div>
    <v-divider class="theme--print" />
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import ImageMedia from '@/components/ImageMedia/ImageMedia.vue'
import Logo from '@/assets/images/logo-rever.png'
import { utils } from 'frontend-js-shared'
import _ from 'lodash'

export default {
  name: 'HeaderRoutinePrint',
  components: {
    ImageMedia,
  },

  props: {
    routineExecution: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      Logo,
    }
  },

  computed: {
    ...mapState({
      logoMediaObject: state => state.access.logoMediaObject,
    }),
    routineExecutionStatus() {
      return this.$t(
        `routines.status.${_.snakeCase(this.routineExecution.status)}`
      )
    },
  },

  methods: {
    formatDate(date, format) {
      return utils.dates.formatDate(date, format)
    },
  },
}
</script>
